import { InjectionToken } from '@angular/core';

export const LocationServiceToken = new InjectionToken<ILocationService>(
  'LocationService',
);

export interface ILocationService {
  assign(url: string);
  replace(url: string);
  reload(forceReload?: boolean);
}
